import React from 'react';
import '../../CSS/AboutPage.css';

function IntroBlock() {

    return (
        <div className="Intro-block">
            <p>
                Hi, I'm <b>Will!</b> It's great to meet you.
            </p>
            <p>
                I've always believed that people are capable of remarkable things. What often holds them back isn't ambition or 
                creativity, but <b>access</b> — to the tools, systems, or clarity they need to bring ideas to life.
            </p>
            <p>
                My work focuses on closing that gap. I build systems and products that <b>reduce friction, simplify complexity, and help users 
                do more with confidence</b>. Whether it is launching new products, improving onboarding, making sense of messy data, or enabling 
                people to make great cocktails at home, my goal remains the same - empower people to believe they can do more.
            </p>
            <p>
                I care deeply about designing solutions that feel <b>intuitive and approachable</b>. The best tools are the ones that meet people 
                where they are, then quietly expand what they are capable of. That mindset is more important than ever with the rise of AI, 
                where the difference between empowering and overwhelming often comes down to how thoughtfully the experience is designed.
            </p>
            <p>
                If you believe in building with <b>clarity, purpose, and genuine respect for the user, I'd love to connect</b>. There are 
                opportunities all around us, because there are people everywhere who deserve to be empowered. I'm always ready to 
                collaborate, share ideas, and help bring a new vision to life. 
            </p>
            <p></p>
            <p><b>Contact me at: </b><a href="mailto:williamliao94@gmail.com">williamliao94@gmail.com</a></p>
        </div>
    )
}

export default IntroBlock;